import { ModalLayoutMobile } from "../../components/PaymentContainer/components/PaymentSelection/components/ModalLayout/ModalLayoutMobile";
import { ModalLayout } from "../../components/PaymentContainer/components/PaymentSelection/components/ModalLayout/ModalLayoutDesktop";
import { getIsMobile } from "../getIsMobile/dev";
export var getModalComponent = function getModalComponent() {
  var isMobile = getIsMobile();
  if (isMobile) return ModalLayoutMobile;
  return ModalLayout;
};